import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryScriptModuleOverview, CommonLibraryScriptModuleTopics } from "../../CommonComponents/CommonLibraryScriptModuleViews";
export const LibraryScriptModulesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.scriptModules.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryScriptModuleOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryScriptModuleTopics />;
    },
};
